import { render, staticRenderFns } from "./IconDocumentSearchOutline.vue?vue&type=template&id=056ff2f0"
import script from "./IconDocumentSearchOutline.vue?vue&type=script&lang=js"
export * from "./IconDocumentSearchOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports